"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceModule = exports.DateFilter = exports.IntegrationApps = exports.QuestionType = void 0;
var QuestionType;
(function (QuestionType) {
    QuestionType["CHECKBOX"] = "CHECKBOX";
    QuestionType["RADIO"] = "RADIO";
    QuestionType["TEXT"] = "TEXT";
    QuestionType["YES_NO"] = "YES_NO";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
var IntegrationApps;
(function (IntegrationApps) {
    IntegrationApps["DOSHII"] = "DOSHII";
    IntegrationApps["ONLINE_STORE"] = "ONLINE_STORE";
    IntegrationApps["OOLIO_STORE"] = "OOLIO_STORE";
    IntegrationApps["XERO"] = "XERO";
    IntegrationApps["DELIVERIT"] = "DELIVERIT";
    IntegrationApps["DEPUTY"] = "DEPUTY";
    IntegrationApps["DELIVERECT"] = "DELIVERECT";
    IntegrationApps["OOLIO_KIOSK"] = "OOLIO_KIOSK";
    IntegrationApps["KIOSK"] = "KIOSK";
    IntegrationApps["QR_PAY"] = "QR_PAY";
    IntegrationApps["OOM"] = "OOM";
    IntegrationApps["OOLIO_RESERVATION"] = "OOLIO_RESERVATION";
    IntegrationApps["OOLIO_WAITLISTS"] = "OOLIO_WAITLISTS";
})(IntegrationApps = exports.IntegrationApps || (exports.IntegrationApps = {}));
var DateFilter;
(function (DateFilter) {
    DateFilter["TODAY"] = "TODAY";
    DateFilter["UPCOMING"] = "UPCOMING";
    DateFilter["OLDER"] = "OLDER";
})(DateFilter = exports.DateFilter || (exports.DateFilter = {}));
var SourceModule;
(function (SourceModule) {
    SourceModule["SHIFTS"] = "SHIFT";
    SourceModule["ORDERS"] = "ORDERS";
})(SourceModule = exports.SourceModule || (exports.SourceModule = {}));
//# sourceMappingURL=integrations.js.map